// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3RiRc","wrapper-nopadding":"wrapper-nopadding__2g7pm","loading":"loading__3p3jy","error":"error__3Gflr","table-loading":"table-loading__2Oe7e","empty-val":"empty-val__38B-k","panelheader-tools":"panelheader-tools__3d5aP","propsPanels":"propsPanels__2GjmY","new":"new__1VQ_x","marginLm":"marginLm__2AxT0","marginRm":"marginRm__2pUx5","fullWidth":"fullWidth__1FV33","fullHeight":"fullHeight__1o9X-","noData":"noData__34F8D","rxdelay":"rxdelay__1agJn","errorBlock":"errorBlock__NCA7d"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/DeviceDetail/coms/DeviceProps/styles.scss
// module id = 2238
// module chunks = 1